import type { DemoMetadata } from "@/registry/types";

export const metadata: DemoMetadata = {
  id: "realtime",
  name: "realtime.name",
  description: "realtime.description",
  longDescription: "realtime.longDescription",
  category: "shared.categories.communication",
  tags: "realtime.tags",
  featured: false,
  status: "live",
  architecture: "realtime.architecture",
  technologies: "realtime.technologies",
  concepts: "realtime.concepts",
  component: () =>
    import("../pages/Demo").then((m) => ({ default: m.RealtimeDemo })),
  i18nNamespace: "realtime",
};
